import {callApi, callEmptyParamsApi} from "../connection/ClientApi";
import Urls from '../connection/Urls';

export const addressViewModel = {
    getAddresses,
    requestSetDefaultAddress,
    requestAddOrEditAddress,
    requestGetProvinces,
    requestGetCities,
    requestGetNeighbourhoods,
    requestDeleteAddress
}

function getAddresses(onSuccess, onFailure, onStart, onEnd) {
    callEmptyParamsApi(Urls.getAddresses, (data) => {
        if (data.list && data.list.length > 0) {
            let index = data.list.findIndex((item) => item.is_default)
            if (index < 0) {
                data.list[0].is_default = true
            }
        }
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}

function requestSetDefaultAddress(address, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("address_id", address.address_id)
    callApi(Urls.setDefaultAddress, params, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}

function requestDeleteAddress(address, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("address_id", address.address_id)
    callApi(Urls.deleteAddress, params, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}

function requestAddOrEditAddress(address, onSuccess, onFailure, onStart, onEnd) {
    let url = Urls.addAddress
    let params = new FormData()
    if (address.address_id > 0) {
        url = Urls.editAddress
        params.append("address_id", address.address_id)
    }

    params.append("addrees_name", address.addrees_name)
    params.append("full_name", address.full_name)
    params.append("telephone", address.telephone)
    params.append("address", address.address)
    params.append("lat_long", address.lat_long)
    params.append("country_id", address.country_id)
    params.append("zone_id", address.zone_id)
    params.append("neighbourhood_id", address.neighbourhood_id)

    callApi(url, params, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}

function requestGetProvinces(onSuccess, onFailure, onStart, onEnd) {
    callEmptyParamsApi(Urls.getProvinces, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}

function requestGetCities(countryId, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("country_id", countryId)
    callApi(Urls.getCities, params, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}

function requestGetNeighbourhoods(zoneId, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("zone_id", zoneId)
    callApi(Urls.getNeighbourhoods, params, (data) => {
        if (onSuccess) {
            onSuccess(data)
        }
    }, (data) => {
        if (onFailure) {
            onFailure(data)
        }
    }, onStart, onEnd)
}